import { BorderedInput, Typography } from '@navi/web-ui/lib/primitives';
import React, { useEffect } from 'react';
import { IRenderingEngine } from '../interfaces/index.type';
import styles from '../index.module.scss';
import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';
import { formatAmount } from '@cp/src/utils/commonUtils';

const Amount: React.FC<IRenderingEngine> = props => {
  const { question, register, error, source, setValue, unregister, clearErrors } = props;
  const { text, mandatory, defaultValue, referenceId, metadata } = question;

  const { validators } = metadata || {};
  const { validatorMeta, maxAmountValidator, minAmountValidator } = validators || {};

  const isValidatorEnabled = !!validatorMeta?.isRequired;
  const isMaxAmountValidatorEnabled = !!maxAmountValidator?.isRequired;
  const isMinAmountValidatorEnabled = !!minAmountValidator?.isRequired;

  const maxAmountWaivedValue = maxAmountValidator?.maxAmount || 0;
  const minAmountWaivedValue = minAmountValidator?.minAmount || 0;

  const validationRules = {
    required: mandatory,
    ...(isValidatorEnabled &&
      isMaxAmountValidatorEnabled && {
        max: {
          value: maxAmountWaivedValue,
          message: 'Enter an amount less than or equal to ' + formatAmount(maxAmountWaivedValue)
        }
      }),
    ...(isValidatorEnabled &&
      isMinAmountValidatorEnabled && {
        min: {
          value: minAmountWaivedValue,
          message: 'Enter an amount more than ' + formatAmount(minAmountWaivedValue)
        }
      })
  };

  const renderError = (type: string, message: string | undefined) =>
    error?.[`${source}_${referenceId}`]?.type === type &&
    message && (
      <Typography variant="p5" className={styles.errorText}>
        {message}
      </Typography>
    );

  useEffect(() => {
    return () => {
      setValue(`${source}_${referenceId}`, undefined);
      unregister(`${source}_${referenceId}`);
      clearErrors(`${source}_${referenceId}`);
    };
  }, []);

  return (
    <>
      <div className={styles.input}>
        <BorderedInput
          labelClassName={styles.label}
          id="amount"
          inputSize="full-width"
          type={'number'}
          inputLabel={
            <>
              {text} {mandatory && <RequiredIcon />}
            </>
          }
          LeftInputAdornment="₹"
          value={defaultValue || ''}
          prefix="₹"
          error={!!error?.[`${source}_${referenceId}`]}
          {...register(`${source}_${referenceId}`, validationRules)}
        />
      </div>
      {renderError('max', validationRules?.max?.message)}
      {renderError('min', validationRules?.min?.message)}
      {error?.[referenceId] && (
        <Typography variant="p5" className={styles.errorText}>
          Please fill the amount
        </Typography>
      )}
    </>
  );
};

export default Amount;
